import { useProcurifyIntl } from '@webapp/hooks'
import { type FinancialAccountBankingDetails } from '@webapp/platform/banking/entities/FinancialAccountBankingDetails/FinancialAccountBankingDetails'
import messages from './messages'

export const useFinancialAccountBankingDetails = ({
  accountDetails,
}: {
  accountDetails: FinancialAccountBankingDetails['fields']
}) => {
  const intl = useProcurifyIntl()

  const keyLabelMap: { [key: string]: string } = {
    name: intl.formatMessage(messages.accountNameLabel),
    accountNumber: intl.formatMessage(messages.accountNumberLabel),
    routingNumber: intl.formatMessage(messages.routingNumberLabel),
    institutionNumber: intl.formatMessage(messages.institutionNumberLabel),
    transitNumber: intl.formatMessage(messages.transitNumberLabel),
    sortCode: intl.formatMessage(messages.sortCodeLabel),
  }

  const accountDetailsKeys = Object.keys(accountDetails)

  const fields = accountDetailsKeys.map((fieldKey) => {
    return {
      label: keyLabelMap[fieldKey],
      value: accountDetails[fieldKey as keyof typeof accountDetails],
    }
  })

  return {
    data: { fields },
    states: { showLoader: accountDetailsKeys.length === 0 },
  }
}
